import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../theme';
const ImageZoom = ({ className, src, alt = 'zoom', zoom: propsZoom = 2, zoomTrigger = 'click', direction = 'normal' }) => {
    const { ImageZoom: css } = useTheme('ImageZoom');
    const containerRef = React.useRef(null);
    const [transformOrigin, setTransformOrigin] = React.useState('center center');
    const [isZoomed, setIsZoomed] = React.useState(false);
    const zoom = Math.max(1, propsZoom);
    React.useEffect(() => {
        const container = containerRef.current;
        if (!container) {
            return undefined;
        }
        const onTouchMove = (e) => {
            if (e.touches.length > 0 && (zoomTrigger === 'hover' || (zoomTrigger === 'click' && isZoomed))) {
                /** При zoom картинки на мобильной версии, блокируем скролл */
                e.preventDefault();
                handleMove(e.touches[0].clientX, e.touches[0].clientY);
            }
        };
        container.addEventListener('touchmove', onTouchMove, { passive: false });
        return () => {
            container.removeEventListener('touchmove', onTouchMove);
        };
    }, [zoomTrigger, isZoomed, direction]);
    const handleSetIsZoomed = (isZoomed) => {
        if (zoomTrigger === 'hover') {
            setIsZoomed(isZoomed);
        }
    };
    const handleMove = (clientX, clientY) => {
        var _a;
        const rect = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (!rect) {
            return;
        }
        let x = ((clientX - rect.left) / rect.width) * 100;
        let y = ((clientY - rect.top) / rect.height) * 100;
        switch (direction) {
            case 'rotate-90':
                [x, y] = [y, 100 - x];
                break;
            case 'rotate-180':
                [x, y] = [100 - x, 100 - y];
                break;
            case 'rotate-270':
                [x, y] = [100 - y, x];
                break;
            case 'normal':
            default:
                break;
        }
        setTransformOrigin(`${x}% ${y}%`);
    };
    const handleMouseMove = (e) => {
        if (zoomTrigger === 'hover' || (zoomTrigger === 'click' && isZoomed)) {
            handleMove(e.clientX, e.clientY);
        }
    };
    const handleClick = (e) => {
        if (zoomTrigger === 'click') {
            setIsZoomed(prev => {
                if (!prev) {
                    handleMove(e.clientX, e.clientY);
                }
                return !prev;
            });
        }
    };
    return (React.createElement("div", { ref: containerRef, className: cn(className, css.container), onClick: handleClick, onMouseMove: handleMouseMove, onMouseEnter: () => handleSetIsZoomed(true), onMouseLeave: () => handleSetIsZoomed(false), onTouchStart: () => handleSetIsZoomed(true), onTouchEnd: () => handleSetIsZoomed(false), onTouchCancel: () => handleSetIsZoomed(false) },
        React.createElement("img", { src: src, alt: alt, className: css.image, style: {
                transform: isZoomed ? `scale(${zoom})` : 'scale(1)',
                transformOrigin
            } })));
};
export default ImageZoom;
